module.exports = __webpack_public_path__ + "img/prop-praline-2.0a93c864.webp";